import React from 'react';
import PropTypes from 'prop-types';

import Textarea from '../Textarea';
import {
  WALDOGRAM_PRINT_TYPE,
  WALDOGRAM_TEXT_CONFIGS,
} from '../../../apps/web-gallery/constants/web-gallery-waldogram-constants';
import { getWaldogramRemainingCaptionChars } from './helpers';

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(WALDOGRAM_PRINT_TYPE)).isRequired,
};

const WaldogramMessageInput = ({ value, onChange, type }) => {
  const { remaining } = getWaldogramRemainingCaptionChars(
    WALDOGRAM_TEXT_CONFIGS[type],
    value,
  );

  return (
    <div className="waldogram-message-wrap">
      <Textarea
        id="waldogram-message"
        className="waldogram-message-input"
        placeholder="Type a message to your recipient..."
        value={value}
        onChange={event => {
          const message = event.target.value;
          const {
            remaining: latestRemaining,
          } = getWaldogramRemainingCaptionChars(
            WALDOGRAM_TEXT_CONFIGS[type],
            message,
          );

          if (latestRemaining >= 0) {
            onChange(message);
          }
        }}
      />
      <span className="waldogram-message-chars">
        {remaining} characters remaining.
      </span>
    </div>
  );
};

WaldogramMessageInput.propTypes = propTypes;

export default WaldogramMessageInput;
